// extracted by mini-css-extract-plugin
export default {"centeredPanel":"centered-panel_centeredPanel__YKyy8"};